import actions from './functional_skills_actions';

const INITIAL_STATE = {
  functionalSkills: [],
  functionalSkillSessionIds: {},
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actions.gotFunctionalSkills:
      return {
        ...state,
        functionalSkills: [...action.data],
      };
    case actions.startedNewSkillSession:
      return {
        ...state,
        functionalSkillSessionIds: { ...state.functionalSkillSessionIds, ...action.data },
      };
    default:
      return { ...state };
  }
}
